enum CategoryStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
}

export default CategoryStatus;
